import React, { useState, useEffect } from "react";
import empty from "is-empty";
import styles from "./styles.module.scss";

export default (props) => {
    // Input(props.data): array
    // Output(set through onChange): array

    const {
        onChange,
        placeholder,
        verifyData,
        id,
        tabIndex,
        data,
        showOrder = false,
        forceUpperCase = false,
        disabled = false,
        ariaLabel,
    } = props;
    const separator = /[;,]/g; // seperate by ';', ','

    const [newElement, setNewElement] = useState("");
    const [elements, setElements] = useState(data);
    const [text, setText] = useState("");
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        setElements(data);
    }, [data]);

    const deleteFromList = (index) => {
        elements.splice(index, 1);
        setElements(elements);
        onChange(elements);
    };

    const addToList = (value = null) => {
        if (!empty(newElement) || !empty(value)) {
            const newElements = (newElement || value).split(separator);
            newElements.forEach((newElement) => {
                if (!empty(newElement))
                    elements.push(forceStringStyle(newElement).trim());
            });
            setElements(elements);
            setNewElement("");
            onChange(elements);
        }
    };

    const switchEditMode = (mode) => {
        if (mode) {
            setText(elements.join(";"));
        } else {
            const edited = text.split(separator).filter((d) => !empty(d));
            setElements(edited);
            onChange(edited);
        }
        setEditMode(mode);
    };

    const forceStringStyle = (value) => {
        if (forceUpperCase) return value.toUpperCase();
        return value;
    };

    const renderList = () => {
        return elements.map((element, index) => {
            let className = "";
            if (verifyData && !verifyData(element)) {
                className = styles.error;
            }
            return (
                <li
                    data-testid={`li-${id}-${index}`}
                    key={`li-${id}-${index}`}
                    className={className}
                >
                    <div
                        onDoubleClick={() => switchEditMode(true)}
                        data-testid={`text-${id}-${index}`}
                        className={styles.text}
                    >
                        {`${showOrder ? index + 1 + " " : ""}${element}`}
                    </div>
                    <div
                        data-testid={`delete-${id}-${index}`}
                        className={`${styles.close} ${className}`}
                        onClick={() => deleteFromList(index)}
                    />
                </li>
            );
        });
    };

    if (editMode) {
        // set edit mode by double click elements
        return (
            <div data-testid={id || "textBox"} className={styles.textBox}>
                <textarea
                    className={styles.editMode}
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder={placeholder}
                    onBlur={() => switchEditMode(false)}
                    onKeyDown={(e) => {
                        if (e.key === "Tab" || e.key === "Enter") {
                            //9: tab, 13: enter
                            e.preventDefault();
                            switchEditMode(false);
                        }
                    }}
                    key={`whole-data-input-${id}`}
                    data-testid={`whole-data-input-${id}`}
                    aria-label={ariaLabel}
                />
            </div>
        );
    }

    return (
        <div data-testid={id || "textBox"} className={styles.textBox}>
            <ul>
                {renderList()}
                <textarea
                    aria-label={ariaLabel}
                    value={newElement}
                    onChange={(e) => setNewElement(e.target.value)}
                    tabIndex={tabIndex || 0}
                    autoFocus={tabIndex === 1}
                    placeholder={elements.length === 0 ? placeholder : ""}
                    style={{
                        width: `${
                            empty(elements) ? 600 : newElement.length * 10
                        }px`,
                    }}
                    onBlur={(e) => addToList()}
                    onPaste={(e) => {
                        e.preventDefault();
                        addToList(e.clipboardData.getData("Text"));
                    }}
                    onKeyDown={(e) => {
                        if (e.key === "Tab" || e.key === "Escape") {
                            addToList();
                        } else if (
                            e.key === "Enter" ||
                            e.key === ";" ||
                            e.key === ","
                        ) {
                            e.preventDefault();
                            addToList();
                        } else if (empty(newElement) && e.key === "Backspace") {
                            e.preventDefault();
                            deleteFromList(elements.length - 1);
                        }
                    }}
                    key={`input-${id}`}
                    data-testid={`input-${id}`}
                    disabled={disabled}
                />
            </ul>
        </div>
    );
};
